import axios from "axios";

// Redirect protection flag (file-level)
let hasRedirected = false;

export const setupInterceptors = (api, baseURL, showSnackbar) => {
  let isRefreshing = false;
  let failedQueue = [];

  const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
      if (error) {
        prom.reject(error);
      } else {
        prom.resolve(token);
      }
    });
    failedQueue = [];
  };

  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      // If token expired and not yet retried
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then(() => api(originalRequest))
            .catch((err) => Promise.reject(err));
        }

        isRefreshing = true;

        try {
          await axios.post(`${baseURL}/auth/refresh-token`, {}, { withCredentials: true });

          processQueue(null);
          return api(originalRequest);
        } catch (refreshError) {
          processQueue(refreshError, null);
          console.error("🔴 Token refresh failed:", refreshError);

          // ✅ Redirect and show snackbar only once
          if (!hasRedirected && typeof window !== "undefined") {
            const currentPath = window.location.pathname;

            // if (currentPath !== "/") {
            //   hasRedirected = true;

            //   // ✅ Show snackbar message (from App)
            //   if (typeof showSnackbar === "function") {
            //     showSnackbar("Session expired. Please login again.");
            //   }

            //   window.location.href = "/";
            // }
          }

          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      }

      return Promise.reject(error);
    }
  );
};
